import React from "react";
import DSBAlogo from "../../Images/DSBAlogo.png";
import DSBACaption from "../../Images/DSBAcaption.png";
// import "./SignInBackground.css";
import "../../Styles/AuthStyle.css";

const SignInLogo: React.FC = () => {
  return (
    <>
      {/* <div className="branddiv d-lg-flex col-12 col-lg-5"> */}
      {/* <div className="signin-logo-wrapper"> */}
      <img className="dsbalogo" src={DSBAlogo} alt="DSBAlogo"></img>
      <img
        className="dsbacaption"
        src={DSBACaption}
        alt="DELAWARE STATE BAR ASSOCIATION"
      ></img>
      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default SignInLogo;
